import { Injectable } from '@angular/core';
import { GridColumn } from '../components/column-visibility-toggle/column-visibility-toggle.component';

@Injectable({ providedIn: 'root' })
export class ColumnVisibilityService {
  loadColumnVisibility(columns: GridColumn[], storageKey: string): void {
    const saved = localStorage.getItem(storageKey);
    if (saved) {
      try {
        const visibility = JSON.parse(saved);
        columns.forEach(col => {
          if (visibility[col.field] !== undefined) {
            col.visible = visibility[col.field];
          }
        });
      } catch (e) {
        console.error('Failed to load column visibility', e);
      }
    }
  }

  saveColumnVisibility(columns: GridColumn[], storageKey: string): void {
    const visibility: Record<string, boolean> = {};
    columns.forEach(col => {
      visibility[col.field] = col.visible !== false;
    });
    localStorage.setItem(storageKey, JSON.stringify(visibility));
  }

  resetColumnVisibility(columns: GridColumn[], storageKey: string): void {
    columns.forEach(col => (col.visible = true));
    this.saveColumnVisibility(columns, storageKey);
  }

  getVisibleColumns(columns: GridColumn[]): GridColumn[] {
    return columns.filter(col => col.visible !== false);
  }

  getFilterRowGridTemplate(
    visibleColumns: GridColumn[],
    widthMap: Record<string, number>
  ): string {
    const columnWidths = visibleColumns
      .map(col => `${widthMap[col.field] || 100}fr`)
      .join(' ');
    return columnWidths;
  }
}
